/**
 * This file contains the core logic of all the things
 * that makes C&C work in Valour Sport, as well as the integrations
 * with various apps like Bundler and Globo Pre-order.
 *
 * To start with this source code, the first place to look at is
 * window.initClickAndCollect which is invoked every time _rerenderCart is
 * invoked in theme.js
 */

document.addEventListener('DOMContentLoaded', function() {

  luxon.Settings.defaultZone = 'utc+11';
  var DateTime = luxon.DateTime;
  let eligibleLocations = [];
  let lineItems = [];
  let lineItemsClickAndCollectEligibility = [];
  let lineItemsForDelivery = [];
  let deliveryOrganisations = [];
  let clickAndCollectFormState = {
    hasCartLoadedAlready: false,
    isEligibleToSelectClickAndCollect: false,
    deliveryType: '',
    clickAndCollectLocation: {},
    clickAndCollectType: '',
    clickAndCollectFields: {},
    prevDeliveryOrg: null,
    deliveryOrg: {},
    deliveryFields: {},
    deliveryRecipient: ''
  };
  let isSubmittingClickAndCollect = false;

  // Clear all Cart attributes except locksmith
  // Get all cart attributes
  if (CartJS && CartJS.cart && typeof CartJS.cart.attributes === 'object') {
    const attributes = CartJS.cart.attributes || {};
    Object.keys(attributes).forEach(function(attr) {
      if (attr !== 'locksmith') {
        CartJS.setAttribute(attr, ''); // Remove by setting to blank
      }
    });
  } else {
    // Fallback: just clear and restore locksmith if present in localStorage
    const locksmithValue = CartJS.cart.attributes?.locksmith || null;
    CartJS.clearAttributes();
    if (locksmithValue !== null) {
      CartJS.setAttribute('locksmith', locksmithValue);
    }
  }

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  /**
   * Sets the form state from local storage. This is used
   * so that the form state is retained even if customer
   * navigates away from the cart page.
   */
  function setFormStateToLocalStorage() {
    console.log('cdebug setFormStateToLocalStorage', clickAndCollectFormState)

    localStorage.setItem("cncFormState", JSON.stringify(clickAndCollectFormState));
  }

  /**
   * Gets the form state from local storage. This is used
   * to restore the form state if the customer comes back to the cart page
   * or loads a page with the cart drawer.
   */
  function getFormStateFromLocalStorage() {
    const formState = localStorage.getItem("cncFormState");
    return formState ? JSON.parse(formState) : null;
  }

  class SearchableDropdown extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.render();
    }

    render(initialValue) {
      const label = this.getAttribute('label') || 'Select an option';
      const options = JSON.parse(this.getAttribute('options') || '[]');
      const targetElement = document.querySelector(this.dataset.targetInput);
      const defaultValue = initialValue ? initialValue : this.getAttribute('value');

      this.innerHTML = `
        <div class="searchable-dropdown">
          <div class="searchable-dropdown-toggle">${defaultValue || label}</div>
          <div class="searchable-dropdown-menu">
            <input type="text" class="searchable-dropdown-search" placeholder="Search..." />
            <div class="searchable-dropdown-options">
              ${options.map(opt => `<div class="searchable-dropdown-option">${opt}</div>`).join('')}
            </div>
          </div>
        </div>
      `;

      const toggle = this.querySelector('.searchable-dropdown-toggle');
      const menu = this.querySelector('.searchable-dropdown-menu');
      const search = this.querySelector('.searchable-dropdown-search');
      const optionEls = this.querySelectorAll('.searchable-dropdown-option');

      toggle.addEventListener('click', () => {
        menu.classList.toggle('show');
        search.value = '';
        this.filterOptions('');
        search.focus();
      });

      optionEls.forEach(option => {
        option.addEventListener('click', () => {
          toggle.textContent = option.textContent;
          this.setAttribute('value', option.textContent);
          this.dispatchEvent(new CustomEvent('change', { detail: { value: option.textContent } }));
          const changeEvent = new Event('change', {
            bubbles: true,
            cancelable: true
          });
          menu.classList.remove('show');

          if(targetElement) {
            targetElement.value = option.textContent;
            targetElement.dispatchEvent(changeEvent);
          }
        });
      });

      search.addEventListener('input', () => {
        this.filterOptions(search.value.toLowerCase());
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          menu.classList.remove('show');
        }
      });
    }


    filterOptions(query) {
      const options = this.querySelectorAll('.searchable-dropdown-option');
      options.forEach(option => {
        option.style.display = option.textContent.toLowerCase().includes(query) ? '' : 'none';
      });
    }
  }

  customElements.define('searchable-dropdown', SearchableDropdown);

  /**
   * This function is used to remove ineligible C&C items in the cart before
   * the cart is submitted to checkout.
   */
  function removeIneligibleClickAndCollectCartItems() {
    const ineligibleForCheckout = lineItemsClickAndCollectEligibility.filter(v => !v.isEligibleForClickAndCollectCheckout);



    if(ineligibleForCheckout.length > 0) {

      ineligibleForCheckout.forEach(lineItem => {
        CartJS.removeItemById(lineItem.id);
      });
    } else {
      // If no items are ineligible, jump ahead
      isSubmittingClickAndCollect = true
      window.bndlr.checkout();
    }

  }


  /**
   * This function declares the parsleyJS's form validation
   * to prevent submission without the users completing
   * all the fields in the C&C form.
   *
   * This function also contains the logic flow on what happens when there
   * are items not eligible for C&C that are in the cart and the user proceeds
   * to checkout where those ineligible line items are removed first programatically.
   */
  function initParsleyValidation() {

    // Make sure to check first if parsley instance is
    // already existing. Destroy it before re-initiating the validation
    if('cartForm' in window && 'destroy' in window.cartForm) {
      window.cartForm.destroy();
    }

    window.cartForm = $('#cart-form').parsley();

    window.cartForm.on('field:validated', function() {
      var cleared = $('.parsley-error').length === 0;
    });


    window.cartForm.on('form:submit', function() {
      var cleared = $('.parsley-error').length === 0;


      if(cleared) {
        if(clickAndCollectFormState.deliveryType.toUpperCase() === 'CLICK & COLLECT' && !isSubmittingClickAndCollect) {
          isSubmittingClickAndCollect = true

          toggleCheckoutButtonState();

          removeIneligibleClickAndCollectCartItems();
          return false;
        } else if(clickAndCollectFormState.deliveryType.toUpperCase() === 'DELIVERY' && !isSubmittingClickAndCollect) {
          isSubmittingClickAndCollect = true

          toggleCheckoutButtonState();

          console.log('cdebug removing')
          removeIneligibleDeliveryCartItems();
          // window.bndlr.checkout();

          return false;
        } else {
          isSubmittingClickAndCollect = false

          window.setTimeout(function() {
            toggleCheckoutButtonState();
          }, 2000);

          window.bndlr.checkout();

          return false;
        }
      }
    });

  }
  /**
   * This is the function that converts the C&C config from Shopify settings
   * into a config that is understood by our code.
   */
  function translateLocationClickAndCollectConfig(rawClickAndCollectConfigArray) {
    return rawClickAndCollectConfigArray.map(function mapRawClickAndCollectConfigArray(clickAndCollectConfig) {

      const locationHandle = typeof clickAndCollectConfig === 'object' && 'location_handle' in clickAndCollectConfig ? clickAndCollectConfig['location_handle'] : '';

      const locationTitle = typeof clickAndCollectConfig === 'object' && 'title' in clickAndCollectConfig ? clickAndCollectConfig['title'] : '';

      const [startDate, endDate] = typeof clickAndCollectConfig === 'object' && 'location_availability' in clickAndCollectConfig ? clickAndCollectConfig['location_availability'].split('|') : ['none','none'];

      let availability = '';
      let availabilityArray = [];

      if(startDate && startDate != 'none') {
        availability += convertStringDateToISODateString(startDate)
      } else {
        availability += 'none'
      }

      availability += '|'


      if(endDate && endDate != 'none') {
        availability += convertStringDateToISODateString(endDate)
      } else {
        availability += 'none'
      }

      if(startDate != 'none' || endDate != 'none') {
        availabilityArray = [availability.trim()]
      }

      let deliveryTypes = [];

      if(clickAndCollectConfig['deliver_store']) {
        deliveryTypes.push(clickAndCollectConfig['deliver_store_type'])
      }

      if(clickAndCollectConfig['deliver_classroom']) {
        deliveryTypes.push('Deliver to classroom')
      }

      return {
        handle: locationHandle,
        title: locationTitle,
        availability: availabilityArray,
        clickAndCollectDefaultFields: clickAndCollectConfig['cc_default_fields'],
        defaultMessageTitle: clickAndCollectConfig['cc_heading_default'],
        defaultMessageSubtitle: clickAndCollectConfig['cc_sub_default'],
        deliveryTypes: deliveryTypes,
        storeMessageTitle: clickAndCollectConfig['store_messaging_title'],
        storeMessageSubtitle: clickAndCollectConfig['store_messaging_subtitle'],
        deliverStoreAdditionalFields: clickAndCollectConfig['deliver_store_additional_fields'],
        classMessageTitle: clickAndCollectConfig['class_messaging_title'],
        classMessageSubtitle: clickAndCollectConfig['class_messaging_subtitle'],
        deliverClassroomAdditionalFields: clickAndCollectConfig['class_additional_fields'],
      }
    })
  }

  /**
   * This is a helper function that converts the C&C datetime string
   * into a ISO Date for compatibility to moment/luxon's DateTime
   */
  function convertStringDateToISODateString(rawDateString) {
    let finalString = '';
    const dateString = rawDateString.trim();

    if(!dateString) {
      return 'none'
    }

    if(dateString == 'none') {
      return 'none'
    }

    const [date,time] = dateString.split(',');

    if(date) {
      finalString += date
    }

    if(time) {
      finalString += 'T'
      finalString += time
      finalString += ':00'
    } else {
      finalString += 'T00:00:00'
    }

    return finalString
  }

  /**
   * This is the function that is used to collect C&C data from the line items.
   * The data is attached to the line items through data attributes which
   * contains data that is set from the metafields for C&C in the products.
   */
  function collectLineItemsClickAndCollectData() {
    const lineItemsNodes = document.querySelectorAll('.CartItem__ClickAndCollect');
    const lineItemsArray = Array.prototype.slice.call(lineItemsNodes);

    const formattedLineItemsForClickAndCollect = lineItemsArray.map(function mapLineItemsForClickAndCollect(lineItem){
      const lineItemId = lineItem.getAttribute('data-click-collect-eligible-line-item-id');
      const lineItemTitle = lineItem.getAttribute('data-click-collect-eligible-line-item-title');
      const isEligibleForClickAndCollect = lineItem.getAttribute('data-click-collect-eligible');
      const isExclusiveForClickAndCollect = lineItem.getAttribute('data-click-collect-exclusive');
      const lineItemAvailabilitySchedule = lineItem.querySelectorAll('div');
      const availabilitySchedulesRawDataArray = Array.prototype.slice.call(lineItemAvailabilitySchedule);
      const lineItemAvailabilitySchedulesArray  = availabilitySchedulesRawDataArray.map(function mapAvailabilitySchedules(availabilityDOMNode) {
        const productLocationAvailabilityRaw = availabilityDOMNode.getAttribute('data-click-collect-schedule') || "";
        const [locationHandle, startDate, endDate] = productLocationAvailabilityRaw.split('|');
        let availability = '';
        let availabilityArray = [];

        if(startDate && startDate != 'none') {
          availability += convertStringDateToISODateString(startDate)
        } else {
          availability += 'none'
        }

        availability += '|'


        if(endDate && endDate != 'none') {
          availability += convertStringDateToISODateString(endDate)
        } else {
          availability += 'none'
        }

        if(startDate != 'none' || endDate != 'none') {
          availabilityArray = [availability.replace(/\s/g, '')]
        }

        return {
          handle: locationHandle ? locationHandle.replace(/\s/g, '') : '',
          availability: availabilityArray
        }
      });

      return {
        id: lineItemId,
        title: lineItemTitle,
        isEligibleForClickAndCollect: isEligibleForClickAndCollect === "true",//this is just a metafield value that indicates if a product is for C&C
        isExclusiveForClickAndCollect: isExclusiveForClickAndCollect === "true",
        clickAndCollectAvailability: lineItemAvailabilitySchedulesArray
      }
    });


    return formattedLineItemsForClickAndCollect;
  }


  /**
   * Returns only the locations which at least 1 item can be delivered for C&C.
   *
   * This is needed as there is a logic that if there is no eligible C&C location based
   * on the line items, then C&C should not be shown as an option
   */
  function getEligibleLocationsFromLineItems(lineItems, locations) {
    let lineItemLocationHandles = lineItems.reduce(function getLineItemLocationHandles(previous, lineItem){
      const clickAndCollectAvailability = Array.isArray(lineItem.clickAndCollectAvailability) && lineItem.clickAndCollectAvailability.length > 0 ? lineItem.clickAndCollectAvailability : [];

      return [...previous, ...clickAndCollectAvailability.map(function(availability){
        return availability.handle
      })]
    }, []);
    lineItemLocationHandles = lineItemLocationHandles.filter(onlyUnique);


    const filteredLocations = locations.filter(function getFilteredLocations(location) {
      const now = DateTime.now();
      let lineItemsClickAndCollectEligibility = getEligibleLineItemsForClickAndCollect({dateTimeNow: now, lineItems: lineItems, locations: locations, selectedLocation: location})


      const numberOfIneligibleLineItems = lineItemsClickAndCollectEligibility.filter((lineItem) => {
        return !lineItem.isEligibleForClickAndCollectCheckout;
      });


      // This means all line items are not eligible
      if(numberOfIneligibleLineItems.length === lineItemsClickAndCollectEligibility.length) {
        return false;
      }

      return true;
    });

    return filteredLocations;
  }

  /**
   * This will show up if there are eligible c&c locations based on the line items
   */
  function generateClickAndCollectOptions(locations) {
    const clickAndCollectLocationSelect = document.querySelector('#click-collect-location');
    const cartCopy = window.vars.cartCopy || {};

    if(clickAndCollectLocationSelect) {

      // Clear the options first
      clickAndCollectLocationSelect.innerHTML = "";

      // Inject first option
      let newOption = document.createElement("option");
      newOption.text = cartCopy.selectLocationPlaceholder || "Select location";
      newOption.value = "";
      newOption.disabled = true;
      clickAndCollectLocationSelect.add(newOption);

      // Inject specific options
      locations.forEach(function injectLocationAsOption(location, index) {
        let newOption = document.createElement("option");
        newOption.text = location.title;
        newOption.value = location.handle;

        clickAndCollectLocationSelect.add(newOption);
      })

    }


  }


  /**
   * This is just a function that returns the location, given the locationHandle
   */
  function getSelectedLocationByHandle(locationHandle) {
    return eligibleLocations.find(function findEligibleLocations(location) {
      return locationHandle === location.handle
    })
  }


  /**
   * This resolves what are eligible line items given the current date
   * and the selected location by the user.
   */
  function getEligibleLineItemsForClickAndCollect({dateTimeNow, lineItems, locations, selectedLocation}) {
    // What is the selected location?


    // Go through each line items
    let clickAndCollectLineItemsEligibility = lineItems.map((lineItem) => {
      const isEligibleForClickAndCollect = lineItem.isEligibleForClickAndCollect;
      const locationAvailabilityOverride = lineItem.clickAndCollectAvailability;
      // Check and get if selected C&C location is available in the product
      const locationAvailabilityOverrideOnSelectedLocation = locationAvailabilityOverride.filter((location) => {
        return selectedLocation.handle === location.handle
      });


      // Check first if product is available for C&C on the selected location
      if(Array.isArray(locationAvailabilityOverrideOnSelectedLocation) && locationAvailabilityOverrideOnSelectedLocation.length === 0) {
        return {
          id: lineItem.id,
          title: lineItem.title,
          locationHandle: selectedLocation.handle,
          isEligibleForClickAndCollectCheckout: false,
          eligibilityReason: '',
          inEligibilityReason: 'PRODUCT_NOT_AVAILABLE_FOR_LOCATION'
        }
      }

      const startDate = getResolvedStartDate({
        lineItemAvailability: locationAvailabilityOverrideOnSelectedLocation,
        locationAvailability: selectedLocation
      });

      const endDate = getResolvedEndDate({
        lineItemAvailability: locationAvailabilityOverrideOnSelectedLocation,
        locationAvailability: selectedLocation
      });



      if(startDate && endDate && (dateTimeNow >= startDate.startDateTime && dateTimeNow <= endDate.endDateTime)) {
        return {
          id: lineItem.id,
          title: lineItem.title,
          locationHandle: selectedLocation.handle,
          isEligibleForClickAndCollectCheckout: true,
          eligibilityReason: 'WITHIN_DATERANGE',
          inEligibilityReason: ''
        }
      } else if(startDate && !endDate && (dateTimeNow >= startDate.startDateTime && !endDate)) {
        return {
          id: lineItem.id,
          title: lineItem.title,
          locationHandle: selectedLocation.handle,
          isEligibleForClickAndCollectCheckout: true,
          eligibilityReason: 'NO_END_DATE',
          inEligibilityReason: ''
        }
      } else if (startDate && endDate && !(dateTimeNow >= startDate.startDateTime && dateTimeNow <= endDate.endDateTime)) {
        return {
          id: lineItem.id,
          title: lineItem.title,
          locationHandle: selectedLocation.handle,
          isEligibleForClickAndCollectCheckout: false,
          eligibilityReason: '',
          inEligibilityReason: 'OUTSIDE_DATERANGE'
        }
      } else if (!startDate) {
        return {
          id: lineItem.id,
          title: lineItem.title,
          locationHandle: selectedLocation.handle,
          isEligibleForClickAndCollectCheckout: false,
          eligibilityReason: '',
          inEligibilityReason: 'NO_START_DATE'
        }
      }else {
        return {
          id: lineItem.id,
          title: lineItem.title,
          locationHandle: selectedLocation.handle,
          isEligibleForClickAndCollectCheckout: false,
          eligibilityReason: '',
          inEligibilityReason: 'INVALID'
        }
      }
    });


    return clickAndCollectLineItemsEligibility.length > 0 ? clickAndCollectLineItemsEligibility : [];
  }

  /**
   * This resolves the c&C start date based on the C&C configuration
   */
  function getResolvedStartDate({ lineItemAvailability, locationAvailability }) {
    const lineItemAvailabilityToCheck = Array.isArray(lineItemAvailability) && lineItemAvailability.length > 0 ? lineItemAvailability[0] : {};
    const lineItemLocationSchedules = 'availability' in lineItemAvailabilityToCheck && lineItemAvailabilityToCheck.availability.length > 0 ? lineItemAvailabilityToCheck.availability[0] : '';

    const [lineItemStartDateStr,] = lineItemLocationSchedules.split('|');
    let lineItemStartDateTime = lineItemStartDateStr && DateTime.fromISO(lineItemStartDateStr.trim());


    if(lineItemStartDateTime && lineItemStartDateTime.isValid) {
      return {
        startDateTime: lineItemStartDateTime,
        location: lineItemAvailabilityToCheck.handle,
        availabilitySource: 'product'
      }
    }

    const locationSchedule = 'availability' in locationAvailability && locationAvailability.availability.length > 0 ? locationAvailability.availability[0] : '';

    const [locationStartDateStr,] = locationSchedule.split('|');
    let locationStartDateTime = locationStartDateStr && DateTime.fromISO(locationStartDateStr.trim());

    if(locationStartDateTime && locationStartDateTime.isValid) {
      return {
        startDateTime: locationStartDateTime,
        location: locationAvailability.handle,
        availabilitySource: 'location'
      }
    }

    return false
  }

  /**
   * This resolves the c&c end date based on the C&C configuration
   */
  function getResolvedEndDate({ lineItemAvailability, locationAvailability }) {
    const lineItemAvailabilityToCheck = Array.isArray(lineItemAvailability) && lineItemAvailability.length > 0 ? lineItemAvailability[0] : {};
    const lineItemLocationSchedules = 'availability' in lineItemAvailabilityToCheck && lineItemAvailabilityToCheck.availability.length > 0 ? lineItemAvailabilityToCheck.availability[0] : '';

    const [lineItemStartDateStr,lineItemEndDateStr] = lineItemLocationSchedules.split('|');
    let lineItemEndDateTime = lineItemEndDateStr && DateTime.fromISO(lineItemEndDateStr.trim());


    if(lineItemEndDateTime && lineItemEndDateTime.isValid) {
      return {
        endDateTime: lineItemEndDateTime,
        location: lineItemAvailabilityToCheck.handle,
        availabilitySource: 'product'
      }
    }

    const locationSchedule = 'availability' in locationAvailability && locationAvailability.availability.length > 0 ? locationAvailability.availability[0] : '';

    const [locationStartDateStr,locationEndDateStr] = locationSchedule.split('|');
    let locationEndDateTime = locationEndDateStr && DateTime.fromISO(locationEndDateStr.trim());

    if(locationEndDateTime && locationEndDateTime.isValid) {
      return {
        endDateTime: locationEndDateTime,
        location: locationAvailability.handle,
        availabilitySource: 'location'
      }
    }


    return false
  }

  /**
   * Function for showing C&C message in each line items
   */
  function printOutClickAndCollectMessagingInLineItems(clickAndCollectLineItems) {
    clickAndCollectLineItems.forEach(function injectClickAndCollectMessagingInLineItems(lineItem) {

      const elementId = '.cnc-' + lineItem.id;
      const elementNodeList = document.querySelectorAll(elementId);
      const elements = Array.prototype.slice.call(elementNodeList);

      Array.isArray(elements) && elements.forEach((element) => {

        if(element) {
          element.innerHTML = '';
          element.appendChild(getClickAndCollectEligibilityMessage(lineItem));
        } else {
          element.appendChild('');
        }

      });

    })
  }

  /**
   * Function for printing out debugging C&C messaging in each line items
   */
  function printOutClickAndCollectMessagingInLineItemsDebug(clickAndCollectLineItems) {
    clickAndCollectLineItems.forEach(function injectClickAndCollectMessagingInLineItems(lineItem) {

      const elementId = '#debug-' + lineItem.id + '-' + lineItem.locationHandle;
      const element = document.querySelector(elementId);

      if(element) {
        element.innerHTML = '';
        element.appendChild(getClickAndCollectEligibilityMessage(lineItem));
      }
    })
  }

  /**
   * This is the function that returns an element that shows
   * a message that a line item is eligible for C&C.
   */
  function getClickAndCollectEligibilityMessage(lineItem) {
    let element = document.createElement('span');
    let elementClassName = 'ClickAndCollectMessage';
    const cartCopy = window.vars.cartCopy || {};

    if(lineItem.isEligibleForClickAndCollectCheckout) {
      element.innerHTML = cartCopy.itemEligibleMessage || 'Available';
      elementClassName += 'ClickAndCollectMessage--Success';
      element.className = elementClassName;

    } else {
      element.innerHTML = cartCopy.itemIneligibleMessage || 'Not Available';
      elementClassName += 'ClickAndCollectMessage--Danger';
      element.className = elementClassName;
    }

    return element;
  }


  /**
   * This is the function that updates line items with line item properties.
   * The line item properties used are are being read in the checkout.liquid logic
   * to determine how the custom messaging will be based on the delivery type
   * that the customer chose before checkout.
   *
   * Here is where globo preorder app's custom line item property is also injected.
   */
  function updateCartItemsWithLineItemProps() {
    $('.CartItem.th_pb_cart_line').each(function(e) {
      var $this = $(this);
      var isPreOrder = $(this).attr('data-pre-order');
      var $qtyInput = $this.find('.QuantitySelector__CurrentQuantity');
      var lineNumber = $qtyInput.attr('data-line');
      var qty = $qtyInput.val();

      let lineItem = CartJS.cart.items.find((v, index) => {
       return +lineNumber === (index + 1)
      });

      if(lineItem) {

        let finalLineItemProps = {
          ...lineItem.properties,
          // Delivery type
          '_delivery_type': clickAndCollectFormState.deliveryType ? clickAndCollectFormState.deliveryType.toLowerCase() : 'delivery',
        };

        // If product is preorder by globo
        if(isPreOrder == 'true') {
          finalLineItemProps['_is_preorder'] = 'Pre-order item'
        }

        CartJS.updateItem(lineNumber, qty, finalLineItemProps);
      }
    });
  }


  /**
   * This is the function that returns the custom values
   * from c&c dynamic fields into the notes.
   */
  function injectDynamicFieldValuesInNotes() {
    let clickAndCollectFieldKeyValues = clickAndCollectFormState.clickAndCollectFields;
    const clickAndCollectFieldKeys = Object.keys(clickAndCollectFieldKeyValues);
    let clickAndCollectAvailableFields = window.vars.clickAndCollectAvailableFields || [];
    let note = '';

    if(clickAndCollectFieldKeys.length > 0) {

      clickAndCollectFieldKeys.forEach(function(key) {
        const fieldName = key;
        const value = clickAndCollectFieldKeyValues[key];
        const fieldData = clickAndCollectAvailableFields.find(v => v.config['input_id'] === fieldName)

        note += `${fieldData && 'config' in fieldData ? fieldData.config.title : fieldName}:\n${value}\n\n`
      })

    }

    return note
  }

  /**
   * This is a function that is a bit of a workaround to create a custom cart note
   * that contains all messaging about the order of the customer. It injects custom
   * information, specially if the user has selected click & collect.
   */
  function updateFinalCartNote() {
    var cartNote = document.querySelector('#final-cart-note');
    var deliveryNote = document.querySelector('#delivery-textarea-note');
    let deliveryType = clickAndCollectFormState.deliveryType;

    if(cartNote) {

      cartNote.value = '';

      if(deliveryType && deliveryType.toLowerCase() !== 'delivery') {

        cartNote.value += `Click & collect location:\n${clickAndCollectFormState.clickAndCollectLocation && 'title' in clickAndCollectFormState.clickAndCollectLocation && clickAndCollectFormState.clickAndCollectLocation.title}\n\n`

        cartNote.value += `Location delivery type:\n${clickAndCollectFormState.clickAndCollectType || 'N/A'}\n\n`

        cartNote.value += injectDynamicFieldValuesInNotes();


      } else {

        if(clickAndCollectFormState?.deliveryOrg?.title) {
          cartNote.value += `Delivery Organisation:\n${clickAndCollectFormState.deliveryOrg && 'title' in clickAndCollectFormState.deliveryOrg && clickAndCollectFormState.deliveryOrg.title}\n\n`
        }

        if(clickAndCollectFormState?.deliveryRecipient) {
          cartNote.value += `Delivery Recipient Type:\n${clickAndCollectFormState.deliveryRecipient || 'N/A'}\n\n`
        }
        cartNote.value += injectDynamicDeliveryFieldValuesInNotes();

        cartNote.value += deliveryNote.value;

        if(cartNote.value.length == 0) {
          CartJS.setNote('')
        }
      }

      console.log('cdebug cartNote', cartNote.value);

    }

  }


  /**
   * This is a function that bind events to all statically defined elements for C&C
   */
  function bindDefaultUIElements() {
    let deliveryMethod = document.querySelector('#delivery-type');
    let deliveryNote = document.querySelector('#delivery-textarea-note');
    let clickAndCollectLocation = document.querySelector('#click-collect-location');
    let checkoutButton = document.querySelector('#fake-checkout-btn');
    let deliveryOrganisation = document.querySelector('#delivery-organisation');

    function onDeliveryMethodChange(e) {
      var value = e.target.value;
      let defaultClickAndCollectState = {
        clickAndCollectLocation: null,
        clickAndCollectType: '',
        clickAndCollectFields: {},
        prevDeliveryOrg: null,
        deliveryOrg: {},
        deliveryFields: {},
        deliveryRecipient: ''
      };

      // Store the in the form state the delivery type
      clickAndCollectFormState.deliveryType = value;

      // Reset delivery org to blank
      clickAndCollectFormState.deliveryOrg = {};

      setFormStateToLocalStorage();

      // Reset Cart Note
      CartJS.setNote('');

      CartJS.setAttribute('delivery_type', value);

      updateCartItemsWithLineItemProps();

      if(value === 'Click & Collect') {
        // Show click and collect form field
        toggleClickAndCollectFieldsVisibility(value);

        // Hide free shipping bar
        toggleCartFreeShippingProgressBar(value);

        // Set Delivery Org to Blank
        CartJS.setAttribute('delivery_org', '');
      } else {
        // Hide click and collect
        toggleClickAndCollectFieldsVisibility(value);

        // Hide free shipping bar
        toggleCartFreeShippingProgressBar(value);

        // Set C&C Location to Blank
        CartJS.setAttribute('click_collect_location', '');
      }

      // Reset click and collect form state
      reloadClickAndCollectState(defaultClickAndCollectState, true);

      // Toggle checkout button state
      toggleCheckoutButtonState();

      updateCartItemsWithLineItemProps();

      updateFinalCartNote();
    }

    function onClickAndCollectLocationChange(e) {
      var value = e.target.value;

      const locationData = getSelectedLocationByHandle(value);

      clickAndCollectFormState.clickAndCollectLocation = locationData;

      clickAndCollectFormState.clickAndCollectType = '';

      // Reset click and collect dynamic field values
      clickAndCollectFormState.clickAndCollectFields = {};


      setFormStateToLocalStorage();

      CartJS.setAttribute('click_collect_location', value);

      // Get C&C Data in Line Items
      const now = DateTime.now();
      lineItemsClickAndCollectEligibility = getEligibleLineItemsForClickAndCollect({dateTimeNow: now, lineItems: lineItems, locations: eligibleLocations, selectedLocation: locationData ? locationData : {}})

      // Display C&C Messaging in Line Items
      printOutClickAndCollectMessagingInLineItems(lineItemsClickAndCollectEligibility);


      // Reload C&C Dynamic Fields
      reloadClickAndCollectDynamicFields(clickAndCollectFormState);


      updateFinalCartNote();
    }

    function onDeliveryOrgChange(e) {
      var value = e.target.value;

      const orgData = getSelectedOrgByHandle(value);

      clickAndCollectFormState.prevDeliveryOrg = clickAndCollectFormState.deliveryOrg;
      clickAndCollectFormState.deliveryOrg = orgData;

      // console.log('cdebug onDeliveryOrgChange')
      clickAndCollectFormState.deliveryRecipient = '';

      // Reset delivery fields dynamic field values ONLY IF delivery org changed
      if(clickAndCollectFormState.prevDeliveryOrg?.organisationHandle != clickAndCollectFormState.deliveryOrg?.organisationHandle) {
        clickAndCollectFormState.deliveryFields = {};
      }

      setFormStateToLocalStorage();

      CartJS.setAttribute('delivery_org', value);

      resetClickAndCollectMessagingInLineItems();

      console.log('cdebug lineItemsForDelivery', lineItemsForDelivery, clickAndCollectFormState);

      const ineligibleDeliveryForCheckout = lineItemsForDelivery.filter((lineItem) => {

        if(clickAndCollectFormState?.deliveryOrg?.removeConfig == 'no_restriction') {
          // Remove all items that have restrictions
          return lineItem.removeConfig == 'cart_org_only' || lineItem.removeConfig == 'cart_org_others'
        } else if(clickAndCollectFormState?.deliveryOrg?.removeConfig == 'cart_org_only') {
          // Find and remove items that are not from the same organisation
          return lineItem.deliveryHandle != clickAndCollectFormState?.deliveryOrg?.organisationHandle
        } else if (clickAndCollectFormState?.deliveryOrg?.removeConfig == 'cart_org_others') {
          // Find and remove items that has delivery handle and delivery handle that is not equal to delivery org of the selected delivery org
          return !!lineItem.deliveryHandle && lineItem.deliveryHandle != clickAndCollectFormState?.deliveryOrg?.organisationHandle
        }

      });

      if(clickAndCollectFormState.deliveryType.toUpperCase() === 'DELIVERY' && clickAndCollectFormState?.deliveryOrg?.organisationHandle && ineligibleDeliveryForCheckout.length > 0) {
        console.log('cdebug printing...')
        printOutDeliveryMessagingInLineItems(ineligibleDeliveryForCheckout);
      }

      reloadDeliveryDynamicFields(clickAndCollectFormState);

      updateFinalCartNote();
    }

    function onCheckoutButtonClick(e) {
      e.preventDefault();
      let form = $('#cart-form');

      // window.cartForm.validate();

      form.submit();
    }

    function onDeliveryNoteChange(e) {
      var value = e.target.value;

      clickAndCollectFormState.deliveryNote = value;

      updateFinalCartNote();

      setFormStateToLocalStorage();
    }

    deliveryMethod && deliveryMethod.removeEventListener('change', onDeliveryMethodChange);
    deliveryNote && deliveryNote.removeEventListener('change', onDeliveryNoteChange);
    clickAndCollectLocation && clickAndCollectLocation.removeEventListener('change', onClickAndCollectLocationChange);
    checkoutButton && checkoutButton.removeEventListener('click', onCheckoutButtonClick);
    deliveryOrganisation && deliveryOrganisation.removeEventListener('change', onDeliveryOrgChange);

    deliveryMethod && deliveryMethod.addEventListener('change', onDeliveryMethodChange);
    deliveryNote && deliveryNote.addEventListener('change', onDeliveryNoteChange);
    clickAndCollectLocation && clickAndCollectLocation.addEventListener('change', onClickAndCollectLocationChange);
    checkoutButton && checkoutButton.addEventListener('click', onCheckoutButtonClick);
    deliveryOrganisation && deliveryOrganisation.addEventListener('change', onDeliveryOrgChange);

  }

  /**
   * This is a function that bind events to all dynamicly generated UI elements
   */
  function bindDynamicUIElements(dynamicUIElements, property) {

    function onDynamicUIElementChange(e) {
      const value = e.target.value;
      const name = e.target.name;

      console.log('cdebug change123', e);

      if(name === 'sub-delivery-type') {

        reloadClickAndCollectState({clickAndCollectType: value})
      } else if(name === 'sub-delivery-recipient-type') {

        reloadClickAndCollectState({deliveryRecipient: value})

      } else if(name && value) {
        clickAndCollectFormState[`${property}`][name] = value;
      }

      setFormStateToLocalStorage();

      updateFinalCartNote();
    }

    dynamicUIElements.forEach(function(uiElement) {
      uiElement.removeEventListener('change', onDynamicUIElementChange);

      uiElement.addEventListener('change', onDynamicUIElementChange);
    });
  }


  /**
   * This toggles UI visilibity of C&C fields if user selected
   * either C&C or Delivery
   */
  function toggleClickAndCollectFieldsVisibility(currentDeliveryMethod) {
    const clickAndCollectFieldsContainer = document.querySelector('#click-collect-fields-container');
    const deliveryFieldsContainer = document.querySelector('#delivery-fields-container');

    if(currentDeliveryMethod === 'Click & Collect') {
      clickAndCollectFieldsContainer && clickAndCollectFieldsContainer.classList.add('--click-and-collect-active');

      deliveryFieldsContainer && deliveryFieldsContainer.classList.add('--click-and-collect-active');
    } else {
      clickAndCollectFieldsContainer && clickAndCollectFieldsContainer.classList.remove('--click-and-collect-active');

      deliveryFieldsContainer && deliveryFieldsContainer.classList.remove('--click-and-collect-active');
    }
  }

  /**
   * This toggles UI visiblity of free shipping bar
   */
  function toggleCartFreeShippingProgressBar(currentDeliveryMethod) {
    const cartDrawerShippingNotice = document.querySelector('.Cart__ShippingNotice');
    const cartDrawerClickCollectHeading = document.querySelector('.CartDrawer__ClickCollectHeading__Message');
    const cartPageShippingHeader = document.querySelector('.SectionHeader__Description.SectionHeader__FreeShipping');
    const cartPageClickCollectHeader = document.querySelector('.SectionHeader__Description.SectionHeader__ClickCollect');


    if(currentDeliveryMethod === 'Click & Collect') {
      // Cart Drawer
      cartDrawerShippingNotice && cartDrawerShippingNotice.classList.add('--click-and-collect-active');
      cartDrawerClickCollectHeading && cartDrawerClickCollectHeading.classList.add('--click-and-collect-active');
      cartDrawerShippingNotice && cartDrawerShippingNotice.classList.remove('--delivery-active');
      cartDrawerClickCollectHeading && cartDrawerClickCollectHeading.classList.remove('--delivery-active');

      // Cart Page
      cartPageShippingHeader && cartPageShippingHeader.classList.add('--click-and-collect-active');
      cartPageClickCollectHeader && cartPageClickCollectHeader.classList.add('--click-and-collect-active');
      cartPageShippingHeader && cartPageShippingHeader.classList.remove('--delivery-active');
      cartPageClickCollectHeader && cartPageClickCollectHeader.classList.remove('--delivery-active');
    } else if(currentDeliveryMethod === 'Delivery') {
      // Cart Drawer
      cartDrawerShippingNotice && cartDrawerShippingNotice.classList.remove('--click-and-collect-active');
      cartDrawerClickCollectHeading && cartDrawerClickCollectHeading.classList.remove('--click-and-collect-active');
      cartDrawerShippingNotice && cartDrawerShippingNotice.classList.add('--delivery-active');
      cartDrawerClickCollectHeading && cartDrawerClickCollectHeading.classList.add('--delivery-active');

      // Cart Page
      cartPageShippingHeader && cartPageShippingHeader.classList.add('--delivery-active');
      cartPageClickCollectHeader && cartPageClickCollectHeader.classList.add('--delivery-active');
      cartPageShippingHeader && cartPageShippingHeader.classList.remove('--click-and-collect-active');
      cartPageClickCollectHeader && cartPageClickCollectHeader.classList.remove('--click-and-collect-active');
    } else {
      // Cart Drawer
      cartDrawerShippingNotice && cartDrawerShippingNotice.classList.remove('--click-and-collect-active');
      cartDrawerClickCollectHeading && cartDrawerClickCollectHeading.classList.remove('--click-and-collect-active');
      cartDrawerShippingNotice && cartDrawerShippingNotice.classList.remove('--delivery-active');
      cartDrawerClickCollectHeading && cartDrawerClickCollectHeading.classList.remove('--delivery-active');

      // Cart Page
      cartPageShippingHeader && cartPageShippingHeader.classList.remove('--delivery-active');
      cartPageClickCollectHeader && cartPageClickCollectHeader.classList.remove('--delivery-active');
      cartPageShippingHeader && cartPageShippingHeader.classList.remove('--click-and-collect-active');
      cartPageClickCollectHeader && cartPageClickCollectHeader.classList.remove('--click-and-collect-active');
    }

  }

  /**
   * This shows an extra messaging if there are exclusively C&C items in the cart
   */
  function showUnavailableMessagingForExclusiveClickCollectItems(eligibleLocations) {
    if(eligibleLocations.length == 0) {
      $('.CartItem__ClickAndCollect--exclusive-error').show();
    }
  }

  /**
   * This function is used for C&C eligiblity debugging purposes only.
   */
  function showClickAndCollectEligibilityStatusDebug(eligibleLocations, lineItems) {
    var eligibleLineItemsPerLocationGroup = [];

    $('.ClickAndCollect_Debug').show();

    eligibleLocations.forEach(function(locationData){

      const now = DateTime.now();

      lineItemsClickAndCollectEligibility = getEligibleLineItemsForClickAndCollect({dateTimeNow: now, lineItems: lineItems, locations: eligibleLocations, selectedLocation: locationData})

      eligibleLineItemsPerLocationGroup.push(lineItemsClickAndCollectEligibility);

    });

    eligibleLineItemsPerLocationGroup.forEach(function(eligibleLineItemsPerLocation) {
      printOutClickAndCollectMessagingInLineItemsDebug(eligibleLineItemsPerLocation)
    })
  }

  /**
   * This function is responsible in resolving which field will be generated,
   * based on the C&C configuration
   */
  function generateClickAndCollectFields(defaultFieldIds, availableFields) {
    const defaultFields = defaultFieldIds.split(',');

    var fields = defaultFields.map(function generateFields(fieldId) {
      const fieldInformation = availableFields.find(v => v.config['input_id'] === fieldId.trim()) || {};

      if('config' in fieldInformation) {
        switch(fieldInformation.type) {
          case 'text_field':
            return generateTextField(fieldInformation.config);
          case 'textarea_field':
            return generateTextAreaField(fieldInformation.config);
          case 'select_field':
            return generateSelectField(fieldInformation.config, false);
          case 'search_field':
            return generateSearchSelectField(fieldInformation.config);
          default:
            return null
        }
      }

      return null;
    });

    return fields;
  }

  /**
 * This function is responsible in generating any select text field HTML on the C&C
 * configuration.
 */
  function generateSearchSelectField(fieldConfig) {
    const id = 'input_id' in fieldConfig ? fieldConfig['input_id'] : '';
    const label = 'title' in fieldConfig ? fieldConfig['title'] : '';
    const placeholder = 'input_placeholder' in fieldConfig ? fieldConfig['input_placeholder'] : '';
    const isRequired = 'is_required' in fieldConfig ? fieldConfig['is_required'] : 'false';
    let formHTML = `<div class="form-control" id="cc-input-container-${id}">`;
    const optionsStr = 'select_options' in fieldConfig ? fieldConfig['select_options'] : '';
    const options = optionsStr.split(',').map(t => t?.trim());

    formHTML += `<input type="text"
                  class="Form__Input ClickAndCollect_Dynamic_Field ClickAndCollect_Dynamic_FieldSearchable"
                  id="cc-input-${id}"
                  name="${id}"
                  ${isRequired ? 'required' : ''}
                  placeholder="${placeholder}" aria-label="${label}"
                  data-parsley-errors-container="#cc-input-error-${id}"
                  autofocus=""/>
                <searchable-dropdown
                  label="${placeholder}"
                  options='${JSON.stringify(options)}'
                  id="searchable-${id}"
                  data-target-input="#cc-input-${id}"></searchable-dropdown>`;
    formHTML += `<div class="error-container" id="cc-input-error-${id}"></div></div>`;
    formHTML += `</div>`;

    console.log('cdebug generateSearchSelectField fieldConfig', fieldConfig)

    return formHTML;
  }

  /**
   * This function is responsible in generating any select text field HTML on the C&C
   * configuration.
   */
  function generateTextField(fieldConfig) {
    const id = 'input_id' in fieldConfig ? fieldConfig['input_id'] : '';
    const label = 'title' in fieldConfig ? fieldConfig['title'] : '';
    const placeholder = 'input_placeholder' in fieldConfig ? fieldConfig['input_placeholder'] : '';
    const isRequired = 'is_required' in fieldConfig ? fieldConfig['is_required'] : 'false';
    let formHTML = `<div class="form-control" id="cc-input-container-${id}">`;
    formHTML += `<input type="text" class="Form__Input ClickAndCollect_Dynamic_Field" id="cc-input-${id}" name="${id}" ${isRequired ? 'required' : ''} placeholder="${placeholder}" aria-label="${label}"  autofocus=""/>`;
    formHTML += `<label class="Form__FloatingLabel">${label}</label>`;
    formHTML += `</div>`;

    return formHTML;
  }

  /**
   * This function is responsible in generating any select textarea field HTML on the C&C
   * configuration.
   */
  function generateTextAreaField(fieldConfig) {

    const id = 'input_id' in fieldConfig ? fieldConfig['input_id'] : '';
    const label = 'title' in fieldConfig ? fieldConfig['title'] : '';
    const placeholder = 'input_placeholder' in fieldConfig ? fieldConfig['input_placeholder'] : '';
    const isRequired = 'is_required' in fieldConfig ? fieldConfig['is_required'] : 'false';

    let formHTML = `<div class="form-control" id="cc-input-container-${id}">`;
    formHTML += `<textarea class="Cart__Note Form__Textarea ClickAndCollect_Dynamic_Field" name="${id}" id="cc-input-${id}" rows="4" placeholder="${placeholder}" ${isRequired ? 'required' : ''}></textarea>`;
    formHTML += `</div>`;

    return formHTML;
  }

  /**
   * This function is responsible in generating any select dropdown field HTML on the C&C
   * configuration.
   */
  function generateSelectField(fieldConfig, placeholderDisabled) {
    const id = 'input_id' in fieldConfig ? fieldConfig['input_id'] : '';
    const label = 'title' in fieldConfig ? fieldConfig['title'] : '';
    const placeholder = 'input_placeholder' in fieldConfig ? fieldConfig['input_placeholder'] : '';
    const isRequired = 'is_required' in fieldConfig ? fieldConfig['is_required'] : 'false';
    const optionsStr = 'select_options' in fieldConfig ? fieldConfig['select_options'] : '';
    const options = optionsStr.split(',');

    let formHTML = `<div class="form-control"><div class="select select--primary form-select" id="cc-input-container-${id}">`;
    formHTML += `<svg class="Icon Icon--select-arrow " role="presentation" viewBox="0 0 19 12"><polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline></svg>`;

    formHTML += `<select title="" class="ClickAndCollect_Dynamic_Field" id="cc-input-${id}" name="${id}" data-parsley-errors-container="#cc-input-error-${id}" ${isRequired ? 'required' : ''}>`;
    formHTML += `<option value="" ${placeholderDisabled ? 'disabled' : ''}>${placeholder}</option>`

    options.forEach(function(option) {
      formHTML += `<option value="${option}">${option}</option>`
    })

    formHTML += `</select>`
    formHTML += `</div>`;
    formHTML += `<div class="error-container" id="cc-input-error-${id}"></div></div>`;

    return formHTML;
  }


  /**
   * This function is purely responsible for rendering to UI
   * the C&C fields specific to the location selected
   */
  function renderClickAndCollectFields(fields, container) {
    fields.forEach(function(field) {
      field && container && container.insertAdjacentHTML('beforeend', field);
    });

  }

  /**
   * This function is just for reloading the values of dynamic fields in the case
   * where DOM is replaced after cart updates.
   */
  function fillUpDynamicFieldValues(clickAndCollectFormState) {
    let clickAndCollectFieldKeyValues = clickAndCollectFormState;
    const clickAndCollectFieldKeys = Object.keys(clickAndCollectFieldKeyValues);

    if(clickAndCollectFieldKeys.length > 0) {
      clickAndCollectFieldKeys.forEach(function(key) {
        const fieldName = key;
        const value = clickAndCollectFieldKeyValues[key];
        const searchableInput = document.querySelector(`#searchable-${fieldName}`);

        value && $(`[name="${fieldName}"]`) && $(`[name="${fieldName}"]`).val(value);
        value && searchableInput && searchableInput?.render(value);
      })
    }

  }

  /**
   * This function generates a select field that provides options to the user
   * about the delivery type they can choose in the C&C location they chose.
   *
   * ie. Deliver to school store, Deliver to classroom
   *
   */
  function generateClickAndCollectDeliveryTypes(clickAndCollectFormState) {
    const selectedLocation = clickAndCollectFormState.clickAndCollectLocation;
    const deliveryTypes = selectedLocation && 'deliveryTypes' in selectedLocation ? selectedLocation.deliveryTypes : [];
    const cartCopy = window.vars.cartCopy || {};

    if(deliveryTypes.length > 0) {

      const deliveryTypesSelect = generateSelectField({
        'input_id': 'sub-delivery-type',
        'title': 'Delivery Type',
        'input_placeholder': cartCopy.selectClickCollectType || 'Select type',
        'is_required': true,
        'select_options': deliveryTypes.join(',')
      }, true);

      return [deliveryTypesSelect]
    }

    return false;
  }

  /**
   * This function just removes the click & collect messaging on
   * instances where there are changes in the c&c options
   * made by the user.
   */
  function resetClickAndCollectMessagingInLineItems() {
    let clickAndCollectMessagesInLineItemNodes = document.querySelectorAll('.CartItem__ClickAndCollectMessages');
    let clickAndCollectMessagesInLineItem = Array.prototype.slice.call(clickAndCollectMessagesInLineItemNodes);

    clickAndCollectMessagesInLineItem.forEach(element => {
      if(element && 'innerHTML' in element) {
        element.innerHTML = ''
      }
    });
  }

  /**
   * This function just prints out to the DOM the C&C messaging
   * for the field groups that are shown depending on the location selected by the customer.
   *
   * @param {string} title
   * @param {string} subtitle
   */
  function printClickAndCollectMessaging(title, subtitle) {
    let fieldGroupTitleElement = document.querySelector('#cc-field-group-title');
    let fieldGroupSubtitleElement = document.querySelector('#cc-field-group-subtitle');

    if(fieldGroupTitleElement && fieldGroupSubtitleElement) {
      fieldGroupTitleElement.innerHTML = title;
      fieldGroupSubtitleElement.innerHTML = subtitle;
    }
  }

  /**
   * This function reloads the click & collect UI state. This is mostly used
   * to initialize the state or retain the UI state after DOM changes were done
   * to the cart via section rendering API.
   *
   * @param {object} incomingFormState - the form object that contains the state data. See clickAndCollectState.js for the form state
   * @param {*} triggedByDeliveryType - this is used to manually reset the delivery type that is set in the form state
   */
  function reloadClickAndCollectState(incomingFormState, triggedByDeliveryType) {
    clickAndCollectFormState = {
      ...clickAndCollectFormState,
      ...incomingFormState
    };

    console.log('cdebug incomingFormState', incomingFormState);
    console.log('cdebug clickAndCollectFormState 1', clickAndCollectFormState);
    console.log('cdebug deliveryOrganisations.length', deliveryOrganisations.length);

    // Reset delivery fields related items if no delivery organisations found
    if(deliveryOrganisations.length == 0) {
      clickAndCollectFormState.deliveryOrg = {};
      clickAndCollectFormState.deliveryFields = {};
      clickAndCollectFormState.deliveryRecipient = ''
      setFormStateToLocalStorage();
    }


    if(incomingFormState && incomingFormState.deliveryType) {
      CartJS.setAttribute('delivery_type', clickAndCollectFormState.deliveryType);
    }

    if(incomingFormState && incomingFormState.clickAndCollectLocation?.handle
      ) {
        CartJS.setAttribute('click_collect_location', clickAndCollectFormState.clickAndCollectLocation.handle);
    }

    // Set Delivery Type Value
    if(!triggedByDeliveryType) {
      $('#delivery-type').val(clickAndCollectFormState.deliveryType);
    }


    // Toggle C&C Field Visibility
    toggleClickAndCollectFieldsVisibility(clickAndCollectFormState.deliveryType);

    // Toggle shipping bar visibility
    toggleCartFreeShippingProgressBar(clickAndCollectFormState.deliveryType)

    // Set Selected C&C Location
    if(clickAndCollectFormState.clickAndCollectLocation && 'handle' in clickAndCollectFormState.clickAndCollectLocation) {
      $('#click-collect-location').val(clickAndCollectFormState.clickAndCollectLocation.handle);
    } else {
      $('#click-collect-location').val('')
    }

    if(clickAndCollectFormState.clickAndCollectLocation) {
      // Note:getEligibleLineItems makes this parent function not pure, due to calling data from outside scope
      const now = DateTime.now();
      lineItemsClickAndCollectEligibility = getEligibleLineItemsForClickAndCollect({dateTimeNow: now, lineItems: lineItems, locations: eligibleLocations, selectedLocation: clickAndCollectFormState.clickAndCollectLocation})


      // Display C&C Messaging in Line Items
      if(clickAndCollectFormState.deliveryType.toUpperCase() === 'CLICK & COLLECT') {
        printOutClickAndCollectMessagingInLineItems(lineItemsClickAndCollectEligibility);
      } else {
        resetClickAndCollectMessagingInLineItems();
      }
    } else {
      // Disable this as this is preventing the messaging on line items from being displayed on page load
      // resetClickAndCollectMessagingInLineItems();
    }

    // Reload C&C Dynamic Fields
    reloadClickAndCollectDynamicFields(clickAndCollectFormState);


    // Auto select delivery organisation if delivery and if no changes is being done to the delivery recipient.
    // The reason is when we trigger event on autoSelectOrganisationIfSingle, the deliveryRecipient gets reset as well.
    if(
      clickAndCollectFormState.deliveryType.toUpperCase() === 'DELIVERY'
      && !incomingFormState?.deliveryRecipient

      ) {
      autoSelectOrganisationIfSingle();
    }

    // Set Delivery Org Cart Attribute
    if(incomingFormState && incomingFormState.deliveryOrg?.organisationHandle
    ) {
      CartJS.setAttribute('delivery_org', clickAndCollectFormState.deliveryOrg.organisationHandle);
    }


    // Toggle Delivery Organisation Visibility
    toggleDeliveryOrganisationVisibility();



    // Set Selected Delivery Organisation
    if(clickAndCollectFormState.deliveryOrg && 'organisationHandle' in clickAndCollectFormState.deliveryOrg) {
      $('#delivery-organisation').val(clickAndCollectFormState.deliveryOrg.organisationHandle
      );
    } else {
      $('#delivery-organisation').val('')
    }

    const ineligibleDeliveryForCheckout = lineItemsForDelivery.filter((lineItem) => {

        if(clickAndCollectFormState?.deliveryOrg?.removeConfig == 'no_restriction') {
          // Remove all items that have restrictions
          return lineItem.removeConfig == 'cart_org_only' || lineItem.removeConfig == 'cart_org_others'
        } else if(clickAndCollectFormState?.deliveryOrg?.removeConfig == 'cart_org_only') {
          // Find and remove items that are not from the same organisation
          return lineItem.deliveryHandle != clickAndCollectFormState?.deliveryOrg?.organisationHandle
        } else if (clickAndCollectFormState?.deliveryOrg?.removeConfig == 'cart_org_others') {
          // Find and remove items that has delivery handle and delivery handle that is not equal to delivery org of the selected delivery org
          return !!lineItem.deliveryHandle && lineItem.deliveryHandle != clickAndCollectFormState?.deliveryOrg?.organisationHandle
        }

      });

    // Set messaging on line items that they will be removed
    if(clickAndCollectFormState?.deliveryOrg?.organisationHandle) {

      // If there are items that will be removed for delivery
      // display messaging in line items
      if(clickAndCollectFormState.deliveryType.toUpperCase() === 'DELIVERY' && clickAndCollectFormState?.deliveryOrg?.organisationHandle && ineligibleDeliveryForCheckout.length > 0) {
        printOutDeliveryMessagingInLineItems(ineligibleDeliveryForCheckout);
      } else {
        resetClickAndCollectMessagingInLineItems();
      }

    } else {
      // Disable this as this is preventing the messaging on line items from being displayed on page load
      // resetClickAndCollectMessagingInLineItems();
    }

    // Reload Delivery Dynamic Fields
    reloadDeliveryDynamicFields(clickAndCollectFormState)


    // Reload Delivery Note
    if(clickAndCollectFormState.deliveryNote) {
      $('#delivery-textarea-note').val(clickAndCollectFormState.deliveryNote)
    }

  }

  /**
   * This large function is responsible in reloading C&C fields
   * that are dynamically generated based on the configuration by the client
   * that is being displayed in window.clickAndCollectAvailableFields.
   *
   * This happens every time there are changes to the cart, mostly triggered
   * by _rerenderCart in theme.js.
   *
   * The reason this exists is because every time _rerenderCart is triggered,
   * the whole DOM that contains the cart page is being replaced totally via
   * section rendering API. In order to preserve the form state changes
   * done by the customer,this function must exist.
   */
  function reloadClickAndCollectDynamicFields(clickAndCollectFormState) {
    // Generate C&C Delivery Types (if there delivery to store or delivery to classroom is available)
    let deliveryTypeFields = generateClickAndCollectDeliveryTypes(clickAndCollectFormState);
    let clickAndCollectDeliveryTypeContainer = document.querySelector('#click-collect-delivery-type-container');

    if(clickAndCollectDeliveryTypeContainer) {
      clickAndCollectDeliveryTypeContainer.innerHTML = '';
    }

    if(deliveryTypeFields && clickAndCollectDeliveryTypeContainer) {
      renderClickAndCollectFields(deliveryTypeFields, clickAndCollectDeliveryTypeContainer);
    }

    printClickAndCollectMessaging('', '');

    // Print C&C Messaging
    if(clickAndCollectFormState.clickAndCollectLocation && 'defaultMessageTitle' in clickAndCollectFormState.clickAndCollectLocation && 'defaultMessageSubtitle' in clickAndCollectFormState.clickAndCollectLocation) {
      printClickAndCollectMessaging(clickAndCollectFormState.clickAndCollectLocation.defaultMessageTitle, clickAndCollectFormState.clickAndCollectLocation.defaultMessageSubtitle);
    }

    // Generate C&C Fields
    let clickAndCollectAvailableFields = window.vars.clickAndCollectAvailableFields || [];

    // Generate default fields
    let mainClickAndCollectContainer = document.querySelector('#main-click-collect-fields-container');

    if(mainClickAndCollectContainer) {
      mainClickAndCollectContainer.innerHTML = '';
    }


    if(clickAndCollectFormState.clickAndCollectLocation && 'clickAndCollectDefaultFields' in clickAndCollectFormState.clickAndCollectLocation) {
      let fields = generateClickAndCollectFields(clickAndCollectFormState.clickAndCollectLocation.clickAndCollectDefaultFields, clickAndCollectAvailableFields);


      renderClickAndCollectFields(fields, mainClickAndCollectContainer);
    }

    if(clickAndCollectFormState.clickAndCollectType) {
      $('#cc-input-sub-delivery-type').val(clickAndCollectFormState.clickAndCollectType);
    } else {
      $('#cc-input-sub-delivery-type').val('')
    }

    // Generate fields for either Deliver to event Store or Pick up from uniform shop or deliver to classroom
    let typeBasedFieldsContainer = document.querySelector('#type-based-click-collect-fields-container');
    if(typeBasedFieldsContainer) {
      typeBasedFieldsContainer.innerHTML = '';
    }

    // If deliver_store_type is Deliver to event Store or Pick up from uniform shop
    if(clickAndCollectFormState.clickAndCollectType.toUpperCase() === 'DELIVER TO EVENT STORE' || clickAndCollectFormState.clickAndCollectType.toUpperCase() === 'PICK UP FROM UNIFORM SHOP') {
      let fields = generateClickAndCollectFields(clickAndCollectFormState.clickAndCollectLocation.deliverStoreAdditionalFields, clickAndCollectAvailableFields)
      renderClickAndCollectFields(fields, typeBasedFieldsContainer);

      // Print specific message if Deliver to event Store or Pick up from uniform shop
      if(clickAndCollectFormState.clickAndCollectLocation && 'storeMessageTitle' in clickAndCollectFormState.clickAndCollectLocation && 'storeMessageSubtitle' in clickAndCollectFormState.clickAndCollectLocation) {
        printClickAndCollectMessaging(clickAndCollectFormState.clickAndCollectLocation.storeMessageTitle, clickAndCollectFormState.clickAndCollectLocation.storeMessageSubtitle);
      }
    } else if (clickAndCollectFormState.clickAndCollectType.toUpperCase() === 'DELIVER TO CLASSROOM') {
      let fields = generateClickAndCollectFields(clickAndCollectFormState.clickAndCollectLocation.deliverClassroomAdditionalFields, clickAndCollectAvailableFields)
      renderClickAndCollectFields(fields, typeBasedFieldsContainer);

      // Print specific message if deliver to classroom
      if(clickAndCollectFormState.clickAndCollectLocation && 'classMessageTitle' in clickAndCollectFormState.clickAndCollectLocation && 'classMessageSubtitle' in clickAndCollectFormState.clickAndCollectLocation) {
        printClickAndCollectMessaging(clickAndCollectFormState.clickAndCollectLocation.classMessageTitle, clickAndCollectFormState.clickAndCollectLocation.classMessageSubtitle);
      }
    }

    fillUpDynamicFieldValues(clickAndCollectFormState.clickAndCollectFields);

    let dynamicUIElementsNodes = document.querySelectorAll('#click-collect-fields-container .ClickAndCollect_Dynamic_Field');
    let dynamicUIElements = Array.prototype.slice.call(dynamicUIElementsNodes);
    bindDynamicUIElements(dynamicUIElements, 'clickAndCollectFields');
  }

  /**
   * This enables the C&C option in the dropdown in cart drawer or cart page
   * if the formatted lineItems data contains eligible products for C&C
   */
  function enableClickAndCollectOptionBasedOnLineItems(lineItems) {
    const eligibleLineItems = lineItems.filter(v => v.isEligibleForClickAndCollect);
    const deliveryTypeSelector = document.querySelector("#delivery-type option[value='Click & Collect']");

    if(eligibleLineItems.length > 0 && deliveryTypeSelector) {
      deliveryTypeSelector.hidden = false;
      deliveryTypeSelector.disabled = false;
    } else if(deliveryTypeSelector) {
      deliveryTypeSelector.hidden = true;
      deliveryTypeSelector.disabled = true;
    }
  }


  /**
   * This toggles the checkout button if it's either
   * disabled or enabled, depending on the logic
   * before this function is invoked.
   */
  function toggleCheckoutButtonState() {
    const checkoutBtn = document.querySelector('#fake-checkout-btn');

    if(isSubmittingClickAndCollect) {
      // Disable checkout button
      checkoutBtn.disabled = true;
      checkoutBtn.classList.add('Cart__Loading');

    }  else {
      // Enable checkout button
      checkoutBtn.disabled = false;
      checkoutBtn.classList.remove('Cart__Loading');
    }

  }

  /**
   * This function removes line items visually that are being removed after
   * an operation to remove line items that cannot be delivered for
   * C&C to a certain location
   */
  function removeLineItemsNotExistingVisually(cart) {
    const existingLineItems = cart.items.map(function(lineItem) {
      return `${lineItem['variant_id']}`
    });
    const lineItemNodes = document.querySelectorAll('.th_pb_cart_line');
    const lineItemElements = Array.prototype.slice.apply(lineItemNodes);

    lineItemElements.forEach(function(element) {
      const elementVariantId  = element && element.getAttribute('d-variant-id')

      if(!existingLineItems.includes(elementVariantId)) {
        element && element.remove();
      }
    });

  }

  /**
   * This function gets eligible C&C items.
   */
  function getExclusiveClickCollectItems(lineItems) {
    return lineItems.filter((lineItem) => {
      return lineItem.isExclusiveForClickAndCollect
    })
  }

  /**
   * This function gets eligible C&C items.
   */
  function getEligibleLineItems(lineItems) {
    return lineItems.filter(v => v.isEligibleForClickAndCollect)
  }

  /**
   * This function disables delivery option if there is at least 1
   * C&C item in the cart.
   */
  function disableDeliveryOption() {
    const deliveryOption = document.querySelector("#delivery-type option[value='Delivery']");

    deliveryOption.disabled = true;
  }


  /**
   * This will show up if there are eligible c&c locations based on the line items
   */
  function generateDeliveryOrganisationOptions(organisations) {
    const deliveryOrganisationSelect = document.querySelector('#delivery-organisation');
    const cartCopy = window.vars.cartCopy || {};

    if(deliveryOrganisationSelect) {

      // Clear the options first
      deliveryOrganisationSelect.innerHTML = "";

      // Inject first option
      let newOption = document.createElement("option");
      newOption.text = cartCopy.deliveryOrganisationPlaceholder || "Select organisation";
      newOption.value = "";
      // newOption.disabled = true;
      deliveryOrganisationSelect.add(newOption);

      // Inject specific options
      organisations.forEach(function injectOrganisationAsOption(organisation, index) {
        let newOption = document.createElement("option");
        newOption.text = organisation.title;
        newOption.value = organisation.organisationHandle;

        deliveryOrganisationSelect.add(newOption);
      });

    }
  }

  function autoSelectOrganisationIfSingle() {
    const deliveryOrganisationSelect = document.querySelector('#delivery-organisation');
    var event = new Event('change');


    if(deliveryOrganisations.length == 1 && deliveryOrganisationSelect) {
      deliveryOrganisationSelect.selectedIndex = 1;

      deliveryOrganisationSelect.dispatchEvent(event);
    }

  }

  function getOrganisationOptionsFromLineItems() {
    const lineItemsNodes = document.querySelectorAll('.CartItem__ClickAndCollect');
    const lineItemsArray = Array.prototype.slice.call(lineItemsNodes);

    const organisations = lineItemsArray.filter((lineItem) => {
      const organisationHandle = lineItem.getAttribute('data-delivery-organisation-handle');

      return organisationHandle;
    })
    .filter((value, index, array) => {
      // Keep only unique organisations
      return array.findIndex((i) => {
        const organisationHandle = i.getAttribute('data-delivery-organisation-handle');

        return organisationHandle == value.getAttribute('data-delivery-organisation-handle');
      }) === index;
    })
    .map((lineItem) => {
      const lineItemId = lineItem.getAttribute('data-delivery-line-item-id');
      const organisationHandle = lineItem.getAttribute('data-delivery-organisation-handle');
      const organisationData = window.vars.productDeliveryConfig.find((deliveryConfig) => {
        return deliveryConfig['org_handle'] == organisationHandle;
      });

      let deliveryRecipientTypes = [];

      if(organisationData?.['recepient_option_1'] && organisationData['option_1_title']) {
        deliveryRecipientTypes.push(organisationData['option_1_title'])
      }

      if(organisationData?.['recepient_option_2'] && organisationData['option_2_title']) {
        deliveryRecipientTypes.push(organisationData['option_2_title'])
      }

      if(organisationData?.['recepient_option_3'] && organisationData['option_3_title']) {
        deliveryRecipientTypes.push(organisationData['option_3_title'])
      }


      return {
        lineItemId,
        organisationHandle,
        title: organisationData?.['title'],
        defaultHeading: organisationData?.['dl_heading_default'],
        defaultSubheading: organisationData?.['dl_sub_default'],
        defaultFields: organisationData?.['dl_default_fields'],
        option1Active: organisationData?.['recepient_option_1'],
        option1Heading: organisationData?.['option_1_title'],
        option1Subheading: organisationData?.['option_1_subtitle'],
        option1Fields: organisationData?.['option_1_additional_fields'],
        option2Active: organisationData?.['recepient_option_2'],
        option2Heading: organisationData?.['option_2_title'],
        option2Subheading: organisationData?.['option_2_subtitle'],
        option2Fields: organisationData?.['option_2_additional_fields'],
        option3Active: organisationData?.['recepient_option_3'],
        option3Heading: organisationData?.['option_3_title'],
        option3Subheading: organisationData?.['option_3_subtitle'],
        option3Fields: organisationData?.['option_3_additional_fields'],
        removeConfig: organisationData?.['remove_config'],
        deliveryRecipientTypes
      }
    })

    return organisations || []
  }


  /**
   * This toggles UI visilibity of C&C fields if user selected
   * either C&C or Delivery
   */
  function toggleDeliveryOrganisationVisibility() {
    const deliveryOrganisationSelect = document.querySelector('.Select--delivery-organisation-container');
    const deliveryFieldGroupTitle = document.querySelector('#del-field-group-title');
    const deliveryFieldGroupSubtitle = document.querySelector('#del-field-group-subtitle');

    // If delivery organisations are more than 1, that's the only time we show it
    if(clickAndCollectFormState?.deliveryType?.toUpperCase() == 'DELIVERY' && deliveryOrganisations.length > 1) {
      deliveryOrganisationSelect && deliveryOrganisationSelect.classList.add('--organisation-select-active');
    } else {
      deliveryOrganisationSelect && deliveryOrganisationSelect.classList.remove('--organisation-select-active');
    }


    if(clickAndCollectFormState?.deliveryType?.toUpperCase() == 'DELIVERY' && deliveryOrganisations.length > 0) {
      deliveryFieldGroupTitle && deliveryFieldGroupTitle.classList.add('--organisation-select-active');
      deliveryFieldGroupSubtitle && deliveryFieldGroupSubtitle.classList.add('--organisation-select-active');

    } else {
      deliveryFieldGroupTitle && deliveryFieldGroupTitle.classList.add('--organisation-select-active');
      deliveryFieldGroupSubtitle && deliveryFieldGroupSubtitle.classList.add('--organisation-select-active');
    }
  }

  function getSelectedOrgByHandle(handle) {
    return deliveryOrganisations.find((org) => {
      return org.organisationHandle == handle
    });
  }


  function reloadDeliveryDynamicFields(clickAndCollectFormState) {
    console.log('cdebug clickAndCollectFormState 1', clickAndCollectFormState);

    // Generate Delivery Options (ie. Deliver to Coach or Delivery to Child)
    let deliveryTypeFields = generateDeliveryRecipientOptions(clickAndCollectFormState);
    let deliveryOrganisationDeliveryTypeContainer = document.querySelector('#delivery-organisation-delivery-type-container');

    if(deliveryOrganisationDeliveryTypeContainer) {
      deliveryOrganisationDeliveryTypeContainer.innerHTML = '';
    }

    if(deliveryTypeFields && deliveryOrganisationDeliveryTypeContainer) {
      renderClickAndCollectFields(deliveryTypeFields, deliveryOrganisationDeliveryTypeContainer);
    }

    printDeliveryFieldsMessaging('', '');

    // Print Default Delivery(C&C) Messaging
    if(clickAndCollectFormState.deliveryOrg && 'defaultHeading' in clickAndCollectFormState.deliveryOrg && 'defaultSubheading' in clickAndCollectFormState.deliveryOrg) {
      printDeliveryFieldsMessaging(clickAndCollectFormState.deliveryOrg.defaultHeading, clickAndCollectFormState.deliveryOrg.defaultSubheading);
    }

    // Generate Delivery(C&C) Fields
    let deliveryAvailableFields = window.vars.deliveryAvailableFields || [];

    // Generate default fields
    let mainDeliveryFieldsContainer = document.querySelector('#main-delivery-organisation-fields-container');

    if(mainDeliveryFieldsContainer) {
      mainDeliveryFieldsContainer.innerHTML = '';
    }


    if(clickAndCollectFormState.deliveryOrg && 'defaultFields' in clickAndCollectFormState.deliveryOrg) {
      let fields = generateClickAndCollectFields(clickAndCollectFormState.deliveryOrg.defaultFields, deliveryAvailableFields);

      renderClickAndCollectFields(fields, mainDeliveryFieldsContainer);
    }

    if(clickAndCollectFormState.deliveryRecipient) {
      $('#cc-input-sub-delivery-recipient-type').val(clickAndCollectFormState.deliveryRecipient);
    } else {
      $('#cc-input-sub-delivery-recipient-type').val('')
    }

    // Generate fields for either Deliver to event Store or Pick up from uniform shop or deliver to classroom
    let typeBasedFieldsContainer = document.querySelector('#type-based-delivery-organisation-fields-container');
    if(typeBasedFieldsContainer) {
      typeBasedFieldsContainer.innerHTML = '';
    }


    if(clickAndCollectFormState?.deliveryOrg?.option1Active && clickAndCollectFormState.deliveryRecipient.toUpperCase() === clickAndCollectFormState?.deliveryOrg?.option1Heading?.toUpperCase()) {
      let fields = generateClickAndCollectFields(clickAndCollectFormState.deliveryOrg.option1Fields, deliveryAvailableFields)
      renderClickAndCollectFields(fields, typeBasedFieldsContainer);

      // Print specific message if Deliver to event Store or Pick up from uniform shop
      if(clickAndCollectFormState.deliveryOrg && 'option1Heading' in clickAndCollectFormState.deliveryOrg && 'option1Subheading' in clickAndCollectFormState.deliveryOrg) {
        printDeliveryFieldsMessaging(clickAndCollectFormState.deliveryOrg.option1Heading, clickAndCollectFormState.deliveryOrg.option1Subheading);
      }

    } else if(clickAndCollectFormState?.deliveryOrg?.option2Active && clickAndCollectFormState.deliveryRecipient.toUpperCase() === clickAndCollectFormState?.deliveryOrg?.option2Heading?.toUpperCase()) {
      let fields = generateClickAndCollectFields(clickAndCollectFormState.deliveryOrg.option2Fields, deliveryAvailableFields)
      renderClickAndCollectFields(fields, typeBasedFieldsContainer);

      // Print specific message if Deliver to event Store or Pick up from uniform shop
      if(clickAndCollectFormState.deliveryOrg && 'option2Heading' in clickAndCollectFormState.deliveryOrg && 'option2Subheading' in clickAndCollectFormState.deliveryOrg) {
        printDeliveryFieldsMessaging(clickAndCollectFormState.deliveryOrg.option2Heading, clickAndCollectFormState.deliveryOrg.option2Subheading);
      }

    } else if(clickAndCollectFormState?.deliveryOrg?.option3Active && clickAndCollectFormState.deliveryRecipient.toUpperCase() === clickAndCollectFormState?.deliveryOrg?.option3Heading?.toUpperCase()) {
      let fields = generateClickAndCollectFields(clickAndCollectFormState.deliveryOrg.option3Fields, deliveryAvailableFields)
      renderClickAndCollectFields(fields, typeBasedFieldsContainer);

      // Print specific message if Deliver to event Store or Pick up from uniform shop
      if(clickAndCollectFormState.deliveryOrg && 'option3Heading' in clickAndCollectFormState.deliveryOrg && 'option3Subheading' in clickAndCollectFormState.deliveryOrg) {
        printDeliveryFieldsMessaging(clickAndCollectFormState.deliveryOrg.option3Heading, clickAndCollectFormState.deliveryOrg.option3Subheading);
      }

    }

    fillUpDynamicFieldValues(clickAndCollectFormState.deliveryFields);

    let dynamicUIElementsNodes = document.querySelectorAll('#delivery-fields-container .ClickAndCollect_Dynamic_Field');
    let dynamicUIElements = Array.prototype.slice.call(dynamicUIElementsNodes);
    bindDynamicUIElements(dynamicUIElements, 'deliveryFields');
  }

  /**
   * This function generates a select field that provides options to the user
   * about the delivery type they can choose in the C&C location they chose.
   *
   * ie. Deliver to school store, Deliver to classroom
   *
   */
  function generateDeliveryRecipientOptions(clickAndCollectFormState) {
    const selectedLocation = clickAndCollectFormState.deliveryOrg;

    console.log('cdebug selectedLocation', clickAndCollectFormState);

    const deliveryRecipientTypes = selectedLocation && 'deliveryRecipientTypes' in selectedLocation ? selectedLocation.deliveryRecipientTypes : [];
    const cartCopy = window.vars.cartCopy || {};

    if(deliveryRecipientTypes.length > 0) {

      const deliveryRecipientTypesSelect = generateSelectField({
        'input_id': 'sub-delivery-recipient-type',
        'title': 'Delivery Recipient',
        'input_placeholder': cartCopy.deliveryRecipientSelectPlaceholder || 'Select type',
        'is_required': true,
        'select_options': deliveryRecipientTypes.join(',')
      }, false);

      return [deliveryRecipientTypesSelect]
    }

    return false;
  }


  /**
   * This function just prints out to the DOM the C&C messaging
   * for the field groups that are shown depending on the location selected by the customer.
   *
   * @param {string} title
   * @param {string} subtitle
   */
  function printDeliveryFieldsMessaging(title, subtitle) {
    let fieldGroupTitleElement = document.querySelector('#del-field-group-title');
    let fieldGroupSubtitleElement = document.querySelector('#del-field-group-subtitle');

    console.log('cdebug printDeliveryFieldsMessaging actual', title, subtitle);
    if(fieldGroupTitleElement && fieldGroupSubtitleElement) {
      fieldGroupTitleElement.innerHTML = title;
      fieldGroupSubtitleElement.innerHTML = subtitle;
    }
  }

  /**
   * This is the function that returns the custom values
   * from c&c dynamic fields into the notes.
   */
  function injectDynamicDeliveryFieldValuesInNotes() {
    let deliveryFieldKeyValues = clickAndCollectFormState.deliveryFields;
    const deliveryFieldKeys = Object.keys(deliveryFieldKeyValues);
    let deliveryAvailableFields = window.vars.deliveryAvailableFields || [];
    let note = '';

    if(deliveryFieldKeys.length > 0) {

      deliveryFieldKeys.forEach(function(key) {
        const fieldName = key;
        const value = deliveryFieldKeyValues[key];
        const fieldData = deliveryAvailableFields.find(v => v.config['input_id'] === fieldName)

        note += `${fieldData && 'config' in fieldData ? fieldData.config.title : fieldName}:\n${value}\n\n`
      })

    }

    return note
  }

  /**
   * This function is used to remove ineligible C&C items in the cart before
   * the cart is submitted to checkout.
   */
  function removeIneligibleDeliveryCartItems() {
    const ineligibleForCheckout = lineItemsForDelivery.filter((lineItem) => {

      if(clickAndCollectFormState?.deliveryOrg?.removeConfig == 'no_restriction') {
        // Remove all items that have restrictions
        return lineItem.removeConfig == 'cart_org_only' || lineItem.removeConfig == 'cart_org_others'
      } else if(clickAndCollectFormState?.deliveryOrg?.removeConfig == 'cart_org_only') {
        // Find and remove items that are not from the same organisation
        return lineItem.deliveryHandle != clickAndCollectFormState?.deliveryOrg?.organisationHandle
      } else if (clickAndCollectFormState?.deliveryOrg?.removeConfig == 'cart_org_others') {
        // Find and remove items that has delivery handle and delivery handle that is not equal to delivery org of the selected delivery org
        return !!lineItem.deliveryHandle && lineItem.deliveryHandle != clickAndCollectFormState?.deliveryOrg?.organisationHandle
      }

    });


    if(clickAndCollectFormState?.deliveryOrg?.organisationHandle && ineligibleForCheckout.length > 0) {
      ineligibleForCheckout.forEach(lineItem => {
        CartJS.removeItemById(lineItem.variantId);
      });
    } else {
      // If no items are ineligible, jump ahead
      isSubmittingClickAndCollect = true
      window.bndlr.checkout();

    }

  }

  function setLineItemsForDelivery() {
    const lineItemsNodes = document.querySelectorAll('.CartItem__ClickAndCollect');
    const lineItems = Array.prototype.slice.call(lineItemsNodes);

    return lineItems.map((lineItem) => {
      let deliveryConfig = window?.vars?.productDeliveryConfig.find((productDeliveryConfig) => {
        return productDeliveryConfig['org_handle'] == lineItem.getAttribute('data-delivery-organisation-handle')
      });


      return {
        variantId: lineItem.getAttribute('data-delivery-line-item-id'),
        deliveryHandle: lineItem.getAttribute('data-delivery-organisation-handle'),
        removeConfig: deliveryConfig ? deliveryConfig['remove_config'] : null
      }
    });
  }


  /**
   * Function for showing C&C message in each line items
   */
  function printOutDeliveryMessagingInLineItems(deliveryLineItems) {
    deliveryLineItems.forEach(function injectDeliveryMessagingInLineItems(lineItem) {


      console.log('cdebug printOutDeliveryMessagingInLineItems', deliveryLineItems)

      const elementId = '.cnc-' + lineItem.variantId;
      const elementNodeList = document.querySelectorAll(elementId);
      const elements = Array.prototype.slice.call(elementNodeList);

      Array.isArray(elements) && elements.forEach((element) => {

        if(element) {
          element.innerHTML = '';
          element.appendChild(getDeliveryEligibilityMessage());
        } else {
          element.appendChild('');
        }

      });

    })
  }

   /**
   * This is the function that returns an element that shows
   * a message that a line item is eligible for C&C.
   */
   function getDeliveryEligibilityMessage() {
    let element = document.createElement('span');
    let elementClassName = 'ClickAndCollectMessage';
    const cartCopy = window.vars.cartCopy || {};

    element.innerHTML = cartCopy.deliveryIneligibleMessage || 'Not Available';
    // element.innerHTML = 'This item will be removed from the cart';
    elementClassName += 'ClickAndCollectMessage--Danger';
    element.className = elementClassName;

    return element;
  }

  /**
   * This function is being called from theme.js after cart
   * drawer has loaded and re-rendered
   */
  window.initClickAndCollect = function initClickAndCollect() {
    let locations = translateLocationClickAndCollectConfig(window.vars.clickAndCollectConfig || []);

    lineItems = collectLineItemsClickAndCollectData();

    let eligibleLineItems = getEligibleLineItems(lineItems);

    let exclusiveClickCollectItems = getExclusiveClickCollectItems(lineItems);

    // Note: If the selected location gets removed, the form field must be reset
    eligibleLocations = getEligibleLocationsFromLineItems(lineItems, locations);


    // If eligible locations is 0, there should be no click and collect option in  the first select dropdown
    generateClickAndCollectOptions(eligibleLocations);


    // Enable C&C option depending on the line items
    eligibleLocations.length > 0 && enableClickAndCollectOptionBasedOnLineItems(lineItems);

    // Disable delivery if there is at least 1 C&C only item
    exclusiveClickCollectItems.length > 0 &&  disableDeliveryOption(eligibleLocations, eligibleLineItems);

    // Show messaging for exclusive C&C items
    showUnavailableMessagingForExclusiveClickCollectItems(eligibleLocations, lineItems);

    lineItemsForDelivery = setLineItemsForDelivery();

    let organisationOptions = getOrganisationOptionsFromLineItems();
    deliveryOrganisations = [...organisationOptions];


    // Generate delivery organisation options
    generateDeliveryOrganisationOptions(organisationOptions);


    bindDefaultUIElements();
    initParsleyValidation();

    // If this setting is true, this will allow you to
    // see debugging messages for C&C
    if(window.vars.enableClickAndCollectDebug) {
      showClickAndCollectEligibilityStatusDebug(eligibleLocations, lineItems);
    }

    let initialFormState = getFormStateFromLocalStorage();


    // If the cart has loaded already, show the necessary C&C fields and load the necessary values in the C&C inputs
    if(clickAndCollectFormState.hasCartLoadedAlready) {
      reloadClickAndCollectState();
    } else {
      clickAndCollectFormState.hasCartLoadedAlready = true;

      if(initialFormState) {
        reloadClickAndCollectState({
          ...initialFormState,
          hasCartLoadedAlready: true
        })
      }
    }

    console.log('cdebug clickAndCollectFormState', clickAndCollectFormState)
    console.log('cdebug lineItemsForDelivery', lineItemsForDelivery, clickAndCollectFormState)

    updateFinalCartNote();
  };

  /**
   * This is the function that reloads the UI state of the cart drawer.
   */
  function reloadCartDrawerSectionsState(e) {

    const cartShippingNoticeContainer = document.querySelector('.Cart__ShippingNotice');
    const freeShippingThresholdCents = cartShippingNoticeContainer && +cartShippingNoticeContainer.getAttribute('data-free-shipping-threshold');
    const latestCartCostCents = e.detail['total_amount_original'];
    const latestCartCostDiscountedCents = e.detail['total_amount_discounted'];
    const remainingSpendContainer = cartShippingNoticeContainer && cartShippingNoticeContainer.querySelector('.RemainingSpend__Container');
    const remainingSpendMoneyContainer = cartShippingNoticeContainer && cartShippingNoticeContainer.querySelector('.RemainingSpendMessage__Container strong');
    const remainingSpendLoadingContainer = cartShippingNoticeContainer && cartShippingNoticeContainer.querySelector('.RemainingSpendBar__Loading');
    const remainingForFreeShipping = freeShippingThresholdCents - latestCartCostDiscountedCents;
    const remainingFreeShippingPercent = (latestCartCostDiscountedCents / freeShippingThresholdCents) * 100;
    const freeShippingContainer = cartShippingNoticeContainer && cartShippingNoticeContainer.querySelector('.FreeShipping__Container');
    const drawerCTAContainer = document.querySelector('.DrawerCTA__Container');
    const productRecommendationsContainer = document.querySelector('.product-recommendations-cart-drawer');


    if(latestCartCostDiscountedCents >= freeShippingThresholdCents) {
      // Show free shipping success message
      freeShippingContainer && freeShippingContainer.classList.add('FreeShipping--active');

      // Hide remaining spend container
      remainingSpendContainer && remainingSpendContainer.classList.add('FreeShipping--active');
    } else {
      freeShippingContainer && freeShippingContainer.classList.remove('FreeShipping--active');
      remainingSpendContainer && remainingSpendContainer.classList.remove('FreeShipping--active');

      if(remainingSpendMoneyContainer) {
        // Update Price
        remainingSpendMoneyContainer.innerHTML = Shopify.formatMoney(remainingForFreeShipping)

      }

      if(remainingSpendLoadingContainer) {
        // Update Bar
        remainingSpendLoadingContainer.style.width = `${remainingFreeShippingPercent}%`
      }

    }

    if(latestCartCostCents <= 0) {
      freeShippingContainer.classList.remove('FreeShipping--active');
      remainingSpendContainer.classList.add('FreeShipping--active');
      drawerCTAContainer && drawerCTAContainer.classList.add('DrawerCTA__Container--empty');
      productRecommendationsContainer && productRecommendationsContainer.classList.add('hidden');
    } else {
      drawerCTAContainer && drawerCTAContainer.classList.remove('DrawerCTA__Container--empty');
      productRecommendationsContainer && productRecommendationsContainer.classList.remove('hidden');
    }


  }


  /**
   * Dependency - Bundler (https://bundler.nice-team.net/)
   * This is an event that we use to watch out for changes
   * to the cart object which we use in order to update
   * the following features in the cart drawer:
   * - Cart free shipping notice
   * - Cart sections visibility
   * - You may also like carousel
   */
  document.addEventListener('bundler:total_cart_values', function(e) {

     /**
      * If cart amount changes, it means something was added to cart.
      * Since bundler has a bug where 'bundler:total_cart_values' fires again and again
      * we implemented this to only fire the DOM manipulations inside this to fire once when
      * there are changes to the cart amount.
      *
      * This solution is also present in theme.js
      */
    if(window.originalCartAmount !== e.detail['total_amount_original']) {
      /**
      * Note:This is where the value of window.originalCartAmount gets updated instead in theme.js because this is the last callback function that is being called in the event listener.
      */
      window.originalCartAmount = e.detail?.['total_amount_original'];

      reloadCartDrawerSectionsState(e);
    }

    if(window.cartLoadedTimes == 0) {
      reloadCartDrawerSectionsState(e);
      window.cartLoadedTimes++
    }

  });

  /**
   * This is a CartJS event that fires when the cart object has been initialized
   */
  $(document).on('cart.ready', function(event, cart) {
    // Make sure to reset the cart state if items in the cart are all removed
    if(cart && cart.items.length == 0) {
      localStorage.setItem("cncFormState", null);
    }
  });

  /**
   * This is a CartJS event that runs after requests has been done.
   *
   * This is used on use cases where there are items in the cart that are not for C&C
   * and are being programatically removed according to the C&C logic.
   *
   * This function will fire bundler app's checkout after the deletion of all
   * cart items that are not meant to be for C&C.
   */
  $(document).on('cart.requestComplete', function (event, cart) {
    // Make sure to reset the cart state if items in the cart are all removed
    if(cart && cart.items.length == 0) {
      localStorage.setItem("cncFormState", null);
    }

    try {

      if(isSubmittingClickAndCollect) {

        console.log('cdebug cart.requestComplete', cart);

        removeLineItemsNotExistingVisually(cart);

        window.bndlr.checkout();
      }

    } catch(error) {
      console.error(error);
    }
  });

})
